import { FormattedMessage } from 'react-intl';

import { WixConnect } from 'widget/player-widget/utils/wix-connect';
import { getContentToShare } from 'widget/components/share-channel/share-channel';

import socialNetworkNames from 'widget/player-widget/constants/social-networks';

import SocialShare from 'widget/player-widget/components/social-share/social-share';

import styles from './share-channel.styl';

import translations from '../../translations';


@WixConnect(styles)
export default class ShareChannel extends React.Component {

  static propTypes = {
    channelData: React.PropTypes.object,
    network: React.PropTypes.string,
    appSettings: React.PropTypes.object,
    onAfterShareClicked: React.PropTypes.func,
  };

  render() {
    const { appSettings, channelData } = this.props;
    const networksClassNames = _.pick(styles, _.values(socialNetworkNames));
    const contentToShare = getContentToShare(channelData, appSettings);

    return (
      <div styleName="share-overlay">
        <div styleName="title">
          <FormattedMessage {...translations.shareThisChannel} />
        </div>
        <SocialShare appSettings={appSettings}
                     networks={_.values(socialNetworkNames)}
                     content={contentToShare}
                     onAfterClicked={this.onAfterShareClicked}
                     styleName="social-icons"
                     buttonClassName={styles['share-icon']}
                     popoutOuterClassName={styles['popout-outer']}
                     popoutInnerClassName={styles['popout-inner']}
                     linkClassName={styles['share-link']}
                     networksClassNames={networksClassNames} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/components/share-channel/share-channel.js